export const reincidenceDefault = {block: '1', reincidence: '2'}

export const reportSignatureDefault = [{id:1,requeired: false, description: '', addComment:false, reqiredComment: false}]